import React from 'react';
import {
  accordionStateOptions, AccordionStateType,
  IMarketplaceFilterCheckboxAllValues,
  IMarketplaceProperty, sortOrderOptions, sortOrderOptionsMap, SortOrderType,
} from 'src/components/profileComponents/Marketplace/types';
import {
  IDevelopmentSpecificationPropChange,
} from 'src/components/profileComponents/Complexes/components/ProjectSpecification/types';
import LabelOutlinedIcon from '@mui/icons-material/LabelOutlined';
import { BoxFormTextField } from 'src/components/profileComponents/FormTextField';
import { translations } from 'src/constants/translations';
import { updateTranslatedField } from 'src/components/profileComponents/Marketplace/components/Filters/helpers';
import { BoxFormAutocomplete } from 'src/components/profileComponents/FormAutocomplete';
import { GroupWrapper } from 'src/components/profileComponents/Marketplace/components/GroupWrapper';
import { useStyles } from 'src/components/profileComponents/Marketplace/components/Filters/components/Tag/styles';
import {
  GroupWrapperFiltersAction,
} from 'src/components/profileComponents/Marketplace/components/GroupWrapperActions/GroupWrapperFiltersAction';
import { InfoTag } from 'src/components/profileComponents/Marketplace/components/Filters/components/InfoTag';

interface ICheckboxProps {
  item: IMarketplaceFilterCheckboxAllValues,
  lang: string,
  propertyOptions: IDevelopmentSpecificationPropChange<IMarketplaceProperty>[]
  onTrash: () => void,
  onChange: (item: IMarketplaceFilterCheckboxAllValues) => void,
}

export const Checkbox: React.FC<ICheckboxProps> = ({
  item, lang, propertyOptions, onTrash, onChange,
}) => {
  const styles = useStyles();
  return (
    <GroupWrapper
      name="Checkbox (all values)"
      startIcon={<LabelOutlinedIcon />}
      actions={(
        <GroupWrapperFiltersAction
          onTrash={onTrash}
          onDrag={() => {}}
        />
      )}
    >
      <div className={styles.tagWrapper}>
        <BoxFormTextField
          label={translations.name}
          name="name"
          defaultValue={item.name?.[lang]}
          onChange={(event) => {
            onChange(updateTranslatedField(item, 'name', lang, event.target.value));
          }}
        />
        <BoxFormTextField
          label={translations.callToAction}
          name="callToAction"
          defaultValue={item.callToActionText?.[lang]}
          onChange={(event) => {
            onChange(updateTranslatedField(item, 'callToActionText', lang, event.target.value));
          }}
        />
        <BoxFormAutocomplete
          label={translations.chooseProperty}
          name="property"
          defaultValue={{ label: item.property?.translates?.[lang] || item.property?.systemName, value: item.property }}
          onChange={(event: IDevelopmentSpecificationPropChange<IMarketplaceProperty>) => {
            onChange({ ...item, property: event.value });
          }}
          options={propertyOptions}
        />
        <BoxFormAutocomplete
          label={translations.sortOrder}
          name="sortOrder"
          defaultValue={
          item.propertyValuesOrder
            ? {
              label: sortOrderOptionsMap[item.propertyValuesOrder],
              value: item.propertyValuesOrder,
            }
            : undefined
        }
          options={sortOrderOptions}
          onChange={(event: IDevelopmentSpecificationPropChange<SortOrderType>) => {
            onChange({ ...item, propertyValuesOrder: event.value });
          }}
        />
        <BoxFormAutocomplete
          label={translations.accordionState}
          name="accordionState"
          defaultValue={{ label: item.accordionState, value: item.accordionState }}
          options={accordionStateOptions}
          onChange={(event: {label: string, value: AccordionStateType}) => {
            onChange({ ...item, accordionState: event.value });
          }}
        />
      </div>
      <InfoTag
        item={item.tooltip}
        lang={lang}
        onChange={(tooltip) => onChange({ ...item, tooltip })}
      />
    </GroupWrapper>
  );
};
